module.exports = __webpack_public_path__ + "img/snapchat_white.b6345f41.png";